const NATIVE_CAPTURE_INTENT = 'intent://capture#Intent;scheme=aiia;package=org.aiia.twa;end';

export function isNativeCaptureAvailable() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  const isAndroid = /Android/i.test(ua);
  const isChromeFamily = /(Chrome|CriOS|SamsungBrowser)/i.test(ua);
  return isAndroid && isChromeFamily;
}

export function launchNativeCapture() {
  if (typeof window === 'undefined') return;
  window.location.href = NATIVE_CAPTURE_INTENT;
}

export function getNativeCaptureIntent() {
  return NATIVE_CAPTURE_INTENT;
}
